import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";
import { RESTRICTION_MAP } from "../constants/restrictions";

// Fix default icon paths (react-leaflet doesn't load them by default)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function colouredIcon(color) {
  return L.divIcon({
    className: "custom-pin",
    html: `<div style="background:${color};width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid white;box-shadow:0 4px 10px rgba(0,0,0,0.25);"></div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -24],
  });
}

export default function MapView({ places = [], height = "500px" }) {
  const withCoords = places.filter((p) => typeof p.latitude === "number" && typeof p.longitude === "number");
  const center = withCoords[0]
    ? [withCoords[0].latitude, withCoords[0].longitude]
    : [-14.235, -51.925]; // Brazil centroid

  return (
    <div data-testid="map-view" className="rounded-3xl overflow-hidden border border-brand-border shadow-md" style={{ height }}>
      <MapContainer center={center} zoom={withCoords.length ? 5 : 4} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {withCoords.map((p) => {
          const main = p.restrictions?.[0] || "vegano";
          const color = RESTRICTION_MAP[main]?.pin || "#2A5C43";
          return (
            <Marker key={p.place_id} position={[p.latitude, p.longitude]} icon={colouredIcon(color)}>
              <Popup>
                <div className="font-heading font-bold text-base text-brand-text">{p.name}</div>
                <div className="text-xs text-brand-textMuted mb-2">{p.city} · {p.state}</div>
                <Link to={`/lugar/${p.place_id}`} className="text-brand-primary font-bold text-sm">Ver detalhes →</Link>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
}
